// extracted by mini-css-extract-plugin
export default {"cls1":"PaperImages-cls1___979a149f032652ef368","cls2":"PaperImages-cls2___363fcb4b6cfa2b1176b PaperImages-cls1___979a149f032652ef368"};